import service from "@/store/services/request-logs-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  requestLog: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, requestLog) => {
    state.requestLog = requestLog;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((requestLog) => {
      commit("SET_RESOURCE", requestLog);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  requestLog: (state) => state.requestLog,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((requestLog) => ({
      id: requestLog.id,
    }));
  },
};

const requestLogs = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default requestLogs;
